import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SigninComponent } from './pages/auth/signin/signin.component';
import { ResetPasswordRequestComponent } from './pages/auth/reset-password-request/reset-password-request.component';
import { ResetPasswordFormComponent } from './pages/auth/reset-password-form/reset-password-form.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { AuthGuard } from './guards/auth.guard';
import { DashGuard } from './guards/dashboard.guard';
import { CheckEmailComponent } from './pages/auth/check-email/check-email.component';
const routes: Routes = [
  { path: "auth/signin", component: SigninComponent, canActivate: [AuthGuard]},
  { path: "auth/forgot-password", component: ResetPasswordRequestComponent},
  { path: "auth/reset-password", component: ResetPasswordFormComponent},
  { path: "auth/account-activation", component: CheckEmailComponent},
  {
    path: 'dashboard',
    canActivate: [DashGuard],
    canLoad: [DashGuard],
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  { path: "not-found", component: NotFoundComponent },
  { path: "", redirectTo: "dashboard", pathMatch: "full" },
  { path: "**", component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
